export class FindAllGroupMembersError {
  public static readonly type =
    '[Group/GroupMembers/List] FindAllGroupMembersError';
  constructor(public readonly error: Error) {}
}
